import { isNowBetweenDates, storeWillOpen } from '~/shared/utils/date-utils';
import type { ReservationStoreBase } from '~/features/product-details/components/ReservationDrawer/types';

export const getStoreOpeningHoursWithStatus = (
    openingHours: ReservationStoreBase['c_openingHours'],
) =>
    openingHours?.map((time) => ({
        ...time,
        isOpen: isNowBetweenDates(time.opens, time.closes),
        willOpenToday: storeWillOpen(time.opens),
    })) ?? [];
